<template>
  <div class="monthly-chart">
    <CCard>
      <CCardBody>
        <h5 class="text-primary">Monthly Applications Overview</h5>
        <div>
          <BasicBar :data="getMonthlyChartData" :height="300" />
        </div>
      </CCardBody>
    </CCard>
  </div>
</template>
<script>
import candidate from "@/containers/KSADashboard/candidate.json";
import BasicBar from "@/components/reusable/Charts/BasicBar.vue";
import { formatDateFormat } from "../../helpers/helper";
export default {
  name: "MonthlyChart",
  components: {
    BasicBar,
  },
  computed: {
    getMonthWiseCount() {
      const counts = candidate.reduce((acc, item) => {
        const date = item.application_date;
        if (!acc[date]) {
          acc[date] = 0;
        }
        acc[date]++;
        return acc;
      }, {});
      return Object.entries(counts).map(([date, count]) => ({
        name: formatDateFormat(date, 'MMM YY'),
        value: count,
      }));
    },
    getMonthlyChartData() {
      const data = this.getMonthWiseCount;
      return [
        {
          name: "No.of Application",
          backgroundColor: "#39e3c9",
          borderColor: "#00ebc7",
          values: data,
        },
        {
          name: "Application Trend",
          backgroundColor: "#9AD0F5",
          borderColor: "#36A2EB",
          values: data,
          type: "line",
          tension: 0.3,
          fill: false,
        },
      ];
    },
  },
};
</script>
